// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Zoypk","disabled":"FileBtn_disabled__vvcV9","warn":"FileBtn_warn__1q2ty","fade":"FileBtn_fade__1kdLB"};